import React from 'react';

import { OutboundLink } from 'gatsby-plugin-google-analytics';

import Topic from '../components/Topic';

import { ReactComponent as LabourIcon } from '../assets/rose.svg';

const topic = {
  "title": "Security Arrangements",
  "results": {
    "deal": {
      "status": "blue",
      "comment": "Agreed until the transition period ends, but then uncertain"
    },
    "disorderly": {
      "status": "red",
      "comment": "No"
    },
    "remain": {
      "status": "green",
      "comment": "Yes"
    },
    "reform": {
      "status": "green",
      "comment": "Yes"
    }
  }
};

const LabSecurity = () => (
  <Topic topic={topic} icon={LabourIcon}>
    <h2>Unambiguous agreements on future security arrangements, such as use of the European arrest warrant.</h2>
    <p>
      One of Labour's five demands for a sensible agreement that can win the support of parliament.
    </p>
  </Topic>
);

export default LabSecurity;
